export class PageRoutes {
  static home = "/";
  static aboutUs = "/who";
  static WorkFromAnywhere = "/where";
  static ticcaProduct = "/what";
  static innovation = "/how";
  static InvestorCenter = "/investor";
  static ExecutiveSummary = "/investor/business-summary";
  static InvestmentOverview = "/investor/investment-overview";
  static ProductOverview = "/investor/product-overview";
  static LoginToken = "/login/verify";
  static WhyChooseUs = "/why";
  static ContactUs = "/contact";
  static When = "/when";
  static Intro = "/investor/intro";
  static question = "/investor/question";
  static qa = "/investor/q&a";
  static factSheet = "/investor/fact-sheet";
  static Projections = "/investor/fy-projections";
  static ShareholderAgreement = "/investor/shareholder-agreement";
  static businessPlan ="/investor/business-plan";
  static ShareSubscriptionForm="/investor/share-subscription-form"
  static SafeFrom="/investor/safe-agreement" ;
  static SafeAgreement="/investor/safe-agreement";
  static CorporateGovernancePolicy = "/investor/corporate-governance-policy";
  static faq = "/investor/faq";
  static Preview = "/investor/preview";
  static AI_Executive_Summary = "/investor/ai-executive-summary";
  static AntiFraudPolicy = "/investor/antifraud-policy";
  static WhistleblowerPolicy = "/investor/whistleblower-policy";
  static DataSecurityPolicy = "/investor/data-security-policy";
  static PrivacyPolicy = "/privacy-policy";
  static TeamsOfUse = "/terms-of-use";
  static CookiePolicy = "/cookie-policy";
  static InvestorRelationsPolicy = "/investor/investor-relations-policy";
  static insights = "/insights"
}
